import ReplacementOrderStatus from 'components/RichProfile/MyAccount/ReplacementOrderStatus/ReplacementOrderStatus';
import { withReplacementOrderStatusProps } from 'viewModel/richProfile/myAccount/replacementOrder/withReplacementOrderStatusProps';

export default withReplacementOrderStatusProps(ReplacementOrderStatus);
